import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import surface from './KensukeSurface.module.scss';

const FACT_KEYS = ['what', 'developer', 'cost', 'purpose'] as const;

/** 検索・引用向けの事実のみ。本文の繰り返し説明は載せない。 */
export default function KensukeProjectOverview() {
  const { t } = useTranslation();

  return (
    <section id="about" className="py-4 bg-white border-top" aria-labelledby="home-about-heading">
      <Container>
        <h2 id="home-about-heading" className={surface.sectionHeading}>
          {t('home.project_overview_title', { defaultValue: 'プロジェクト概要' })}
        </h2>
        <dl className={`mb-0 mt-3 ${surface.requestsCard} ${surface.panel}`}>
          {FACT_KEYS.map((key, index) => (
            <div
              key={key}
              className={index < FACT_KEYS.length - 1 ? 'mb-3 pb-3 border-bottom' : ''}
            >
              <dt className="fw-semibold mb-1">{t(`home.project_overview_${key}_q`)}</dt>
              <dd className="text-muted mb-0">{t(`home.project_overview_${key}_a`)}</dd>
            </div>
          ))}
        </dl>
      </Container>
    </section>
  );
}
